export interface RefundRequestState {
  isLoading: boolean | null;
}
export const initialState = {
  isLoading: null,
};